interface II18nTexts {
  [key: string]: {
    [key: string]: string;
  };
}

const translationTexts: II18nTexts = {
  ko: {
    "main.loading": "로딩 중입니다.",
    "main.alreadySubmitting": "제출 중입니다.",
    "main.submitFailed": "제출에 실패했습니다.",
    "common.inputRequired": "필수",
    "common.inputMaxChoice": "최대 {{max}}개 선택",
    "common.successTitle": "제출 완료!",
    "common.fileMaxSize": "파일이 10MB를 초과합니다. 업로드할 수 없습니다.",
    "common.fileType": "지원하지 않는 파일 형식입니다.",
    "common.fileMaxCount": "파일은 최대 {{max}}개까지 업로드 가능합니다.",
    "formSurvey.successTitle": "제출 완료!",
    "formSurvey.successDescription": "설문조사에 참여해 주셔서 감사합니다.",
    "formSurvey.failTitle": "설문조사 참여 불가!",
    "formSurvey.failDescription": "진행 중인 설문조사가 아닙니다.",
    "formEvent.successTitle": "제출 완료!",
    "formEvent.successDescription": "이벤트에 참여해 주셔서 감사합니다.",
    "formEvent.failTitle": "이벤트 참여 불가!",
    "formEvent.failDescription": "진행 중인 이벤트가 아닙니다.",
    "promotion.successTitle": "제출 완료!",
    "promotion.successDescription": "프로모션에 참여해 주셔서 감사합니다.",
    "promotion.failTitle": "프로모션 참여 불가!",
    "promotion.failDescription": "진행 중인 프로모션이 아닙니다.",
    "collection.failDescription": "진행 중인 컬렉션이 아닙니다.",
    list: "목록",

    // easyCanvas: Common
    "easyCanvas.common.brandName": "이지캔버스",
    "easyCanvas.common.exit": "나가기",
    "easyCanvas.common.close": "닫기",
    "easyCanvas.common.confirm": "확인",
    "easyCanvas.common.cancel": "취소",
    "easyCanvas.common.edit": "편집",
    "easyCanvas.common.save": "저장",
    "easyCanvas.common.delete": "삭제",
    "easyCanvas.common.reset": "초기화",
    "easyCanvas.common.apply": "적용",
    "easyCanvas.common.previous": "이전",

    // easyCanvas: Floating
    "easyCanvas.floating.description":
      "생성한 캠페인을 추가하여 미리 확인해보세요. 확인한 캠페인을 바로 적용해볼 수 있어요!",
    "easyCanvas.floating.tabs.checkOnMobile": "모바일에서 확인하기",
    "easyCanvas.floating.tabs.changeToMobileOnPc": "PC에서 모바일 변경하기",
    "easyCanvas.floating.tooltip.mobileGuide": "모바일 변경 안내",
    "easyCanvas.floating.qrGenerating": "QR 코드 생성 중...",
    "easyCanvas.floating.qrCodeAlt": "모바일 접속 QR 코드",
    "easyCanvas.floating.exitConfirm.body":
      "이지캔버스 모드를 나가시겠습니까?",
    "easyCanvas.floating.mobileGuide.title": "모바일 변경 안내",
    "easyCanvas.floating.mobileGuide.description":
      "모바일 버전으로 변경하여 이지캔버스를 사용해보세요.",
    "easyCanvas.floating.mobileGuide.checkTab.instruction":
      "핸드폰으로 QR코드를 인식하여\n모바일에서 이지캔버스를 사용해보세요",
    "easyCanvas.floating.mobileGuide.pcTab.step1":
      "마우스 우클릭 후 '검사' 클릭 또는 F12를 클릭해서 개발자 모드로 변경해주세요",
    "easyCanvas.floating.mobileGuide.pcTab.step2":
      "예시 이미지의 아이콘 (Toggle device toolbar)을 클릭 후 새로고침 해주세요",
    "easyCanvas.floating.mobileGuide.pcTab.step3":
      "모바일 화면에서 캠페인을 확인해보세요",
    "easyCanvas.floating.mobileGuide.pcTab.devToolsGuideAlt":
      "개발자 모드 가이드",

    // easyCanvas: Embedded Toolbar
    "easyCanvas.embeddedToolbar.toast.noDataToSave":
      "저장할 데이터가 없습니다.",
    "easyCanvas.embeddedToolbar.toast.deleteSuccess": "삭제되었습니다.",
    "easyCanvas.embeddedToolbar.toast.deleteFailed": "삭제에 실패했습니다.",
    "easyCanvas.embeddedToolbar.toast.saveSuccess": "저장되었습니다.",
    "easyCanvas.embeddedToolbar.toast.saveFailed": "저장에 실패했습니다.",
    "easyCanvas.embeddedToolbar.deleteModal.title": "영역 삭제",
    "easyCanvas.embeddedToolbar.deleteModal.body": "정말로 삭제하시겠습니까?",
    "easyCanvas.embeddedToolbar.styleModal.title": "영역 스타일 설정",
    "easyCanvas.embeddedToolbar.styleModal.alignSection": "위치 정렬",
    "easyCanvas.embeddedToolbar.styleModal.paddingSection": "여백",
    "easyCanvas.embeddedToolbar.saveModal.body1":
      "해당 영역에 캠페인을 노출하시겠습니까?",
    "easyCanvas.embeddedToolbar.saveModal.body2":
      "영역 등록 후 공개 설정으로 변경 시 캠페인이 노출됩니다!",
    "easyCanvas.embeddedToolbar.saveModal.note":
      "*이미 공개된 캠페인일 경우 즉시 반영될 수 있습니다.",

    // easyCanvas: Element Selector
    "easyCanvas.elementSelector.toast.campaignAdded":
      "{{name}} 캠페인이 추가되었습니다. 적용하려면 저장해주세요.",
    "easyCanvas.elementSelector.contextMenu.areaId": "영역 ID",
    "easyCanvas.elementSelector.contextMenu.navigatePage": "페이지 이동",
    "easyCanvas.elementSelector.contextMenu.addBeforeSelection":
      "선택한 영역 이전에 추가",
    "easyCanvas.elementSelector.contextMenu.addAfterSelection":
      "선택한 영역 다음에 추가",

    // easyCanvas: Popup Drawer
    "easyCanvas.popupDrawer.title": "캠페인 목록",
    "easyCanvas.popupDrawer.showOneByOne": "하나씩 보기",
    "easyCanvas.popupDrawer.badge.active": "공개",
    "easyCanvas.popupDrawer.badge.inactive": "비공개",

    // easyCanvas: Schedule Badge
    "easyCanvas.scheduleBadge.scheduled": "예약 공개",
    "easyCanvas.scheduleBadge.immediate": "바로 공개",

    // easyCanvas: Alerts
    "easyCanvas.alert.siteIdMismatch":
      "[코드앤버터] 설치된 스크립트의 사이트 ID가 일치하지 않습니다.\n설치된 스크립트 ID: {{siteId}}\n[사이트 설정] - [아이디]를 확인해주세요.\n*자세한 사항은 채널톡으로 문의해주세요.",
    "easyCanvas.alert.sessionExpired":
      "[코드앤버터] 세션이 만료되었습니다. 이지캔버스를 종료합니다.",
    "easyCanvas.alert.authFailed":
      "[코드앤버터] 인증이 실패했습니다. 코드앤버터에서 다시 접속해주세요. 문제가 반복되면 관리자에게 문의해주세요.",
    "easyCanvas.alert.authResultInvalid":
      "[코드앤버터] 인증 결과가 잘못되었습니다. 코드앤버터에서 다시 접속해주세요. 문제가 반복되면 관리자에게 문의해주세요.",
    "easyCanvas.alert.reAuthFailed":
      "[코드앤버터] 재인증이 실패했습니다. 코드앤버터에서 다시 접속해주세요. 문제가 반복되면 관리자에게 문의해주세요.",
    "easyCanvas.alert.unknownAuthError":
      "[코드앤버터] 인증에서 알 수 없는 에러가 발생했습니다. 코드앤버터에서 다시 접속해주세요. 문제가 반복되면 관리자에게 문의해주세요.",
  },
  en: {
    "main.loading": "Loading...",
    "main.alreadySubmitting": "Submitting...",
    "main.submitFailed": "Submission failed.",
    "common.inputRequired": "Required",
    "common.inputMaxChoice": "Select up to {{max}}",
    "common.successTitle": "Submission completed!",
    "common.fileMaxSize": "The file exceeds 10MB. It cannot be uploaded.",
    "common.fileType": "Unsupported file type.",
    "common.fileMaxCount": "You can upload up to {{max}} files.",
    "formSurvey.successTitle": "Submission completed!",
    "formSurvey.successDescription":
      "Thank you for participating in the survey.",
    "formSurvey.failTitle": "You can't participate in the survey!",
    "formSurvey.failDescription": "This is not an ongoing survey.",
    "formEvent.successTitle": "Submission completed!",
    "formEvent.successDescription": "Thank you for participating in the event.",
    "formEvent.failTitle": "You can't participate in the event!",
    "formEvent.failDescription": "This is not an ongoing event.",
    "promotion.successTitle": "Submission completed!",
    "promotion.successDescription":
      "Thank you for participating in the promotion.",
    "promotion.failTitle": "You can't participate in the promotion!",
    "promotion.failDescription": "This is not an ongoing promotion.",
    "collection.failDescription": "This is not an ongoing collection.",
    list: "List",

    // easyCanvas: Common
    "easyCanvas.common.brandName": "EasyCanvas",
    "easyCanvas.common.exit": "Exit",
    "easyCanvas.common.close": "Close",
    "easyCanvas.common.confirm": "OK",
    "easyCanvas.common.cancel": "Cancel",
    "easyCanvas.common.edit": "Edit",
    "easyCanvas.common.save": "Save",
    "easyCanvas.common.delete": "Delete",
    "easyCanvas.common.reset": "Reset",
    "easyCanvas.common.apply": "Apply",
    "easyCanvas.common.previous": "Previous",

    // easyCanvas: Floating
    "easyCanvas.floating.description":
      "Add your campaigns to preview them. You can apply previewed campaigns right away!",
    "easyCanvas.floating.tabs.checkOnMobile": "Check on mobile",
    "easyCanvas.floating.tabs.changeToMobileOnPc": "Switch to mobile on PC",
    "easyCanvas.floating.tooltip.mobileGuide": "Mobile guide",
    "easyCanvas.floating.qrGenerating": "Generating QR code...",
    "easyCanvas.floating.qrCodeAlt": "Mobile access QR code",
    "easyCanvas.floating.exitConfirm.body":
      "Are you sure you want to exit EasyCanvas mode?",
    "easyCanvas.floating.mobileGuide.title": "Mobile Guide",
    "easyCanvas.floating.mobileGuide.description":
      "Switch to the mobile version to use EasyCanvas.",
    "easyCanvas.floating.mobileGuide.checkTab.instruction":
      "Scan the QR code with your phone\nto use EasyCanvas on mobile",
    "easyCanvas.floating.mobileGuide.pcTab.step1":
      "Right-click and select 'Inspect' or press F12 to open Developer Tools",
    "easyCanvas.floating.mobileGuide.pcTab.step2":
      "Click the Toggle device toolbar icon shown in the image, then refresh",
    "easyCanvas.floating.mobileGuide.pcTab.step3":
      "Check your campaigns on the mobile view",
    "easyCanvas.floating.mobileGuide.pcTab.devToolsGuideAlt":
      "Developer Tools guide",

    // easyCanvas: Embedded Toolbar
    "easyCanvas.embeddedToolbar.toast.noDataToSave": "No data to save.",
    "easyCanvas.embeddedToolbar.toast.deleteSuccess": "Deleted successfully.",
    "easyCanvas.embeddedToolbar.toast.deleteFailed": "Failed to delete.",
    "easyCanvas.embeddedToolbar.toast.saveSuccess": "Saved successfully.",
    "easyCanvas.embeddedToolbar.toast.saveFailed": "Failed to save.",
    "easyCanvas.embeddedToolbar.deleteModal.title": "Delete Area",
    "easyCanvas.embeddedToolbar.deleteModal.body":
      "Are you sure you want to delete?",
    "easyCanvas.embeddedToolbar.styleModal.title": "Area Style Settings",
    "easyCanvas.embeddedToolbar.styleModal.alignSection": "Alignment",
    "easyCanvas.embeddedToolbar.styleModal.paddingSection": "Margin",
    "easyCanvas.embeddedToolbar.saveModal.body1":
      "Would you like to display the campaign in this area?",
    "easyCanvas.embeddedToolbar.saveModal.body2":
      "After registering the area, the campaign will be displayed when set to public!",
    "easyCanvas.embeddedToolbar.saveModal.note":
      "*Already published campaigns may be applied immediately.",

    // easyCanvas: Element Selector
    "easyCanvas.elementSelector.toast.campaignAdded":
      "{{name}} campaign has been added. Save to apply.",
    "easyCanvas.elementSelector.contextMenu.areaId": "Area ID",
    "easyCanvas.elementSelector.contextMenu.navigatePage": "Navigate to page",
    "easyCanvas.elementSelector.contextMenu.addBeforeSelection":
      "Add before selected area",
    "easyCanvas.elementSelector.contextMenu.addAfterSelection":
      "Add after selected area",

    // easyCanvas: Popup Drawer
    "easyCanvas.popupDrawer.title": "Campaign List",
    "easyCanvas.popupDrawer.showOneByOne": "Show one by one",
    "easyCanvas.popupDrawer.badge.active": "Public",
    "easyCanvas.popupDrawer.badge.inactive": "Private",

    // easyCanvas: Schedule Badge
    "easyCanvas.scheduleBadge.scheduled": "Scheduled",
    "easyCanvas.scheduleBadge.immediate": "Immediate",

    // easyCanvas: Alerts
    "easyCanvas.alert.siteIdMismatch":
      "[Codenbutter] The installed script's site ID does not match.\nInstalled script ID: {{siteId}}\nPlease check [Site Settings] - [ID].\n*For details, please contact us via ChannelTalk.",
    "easyCanvas.alert.sessionExpired":
      "[Codenbutter] Session expired. Exiting EasyCanvas.",
    "easyCanvas.alert.authFailed":
      "[Codenbutter] Authentication failed. Please reconnect from Codenbutter. If the problem persists, contact the administrator.",
    "easyCanvas.alert.authResultInvalid":
      "[Codenbutter] Invalid authentication result. Please reconnect from Codenbutter. If the problem persists, contact the administrator.",
    "easyCanvas.alert.reAuthFailed":
      "[Codenbutter] Re-authentication failed. Please reconnect from Codenbutter. If the problem persists, contact the administrator.",
    "easyCanvas.alert.unknownAuthError":
      "[Codenbutter] An unknown authentication error occurred. Please reconnect from Codenbutter. If the problem persists, contact the administrator.",
  },
  ja: {
    "main.loading": "ローディング。",
    "main.alreadySubmitting": "送信中です。",
    "main.submitFailed": "送信に失敗しました。",
    "common.inputRequired": "必須",
    "common.inputMaxChoice": "最大{{max}}個選択",
    "common.successTitle": "提出済み!",
    "common.fileMaxSize":
      "ファイルが10MBを超えています。アップロードできません。",
    "common.fileType": "サポートされていないファイル形式です。",
    "common.fileMaxCount": "ファイルは最大{{max}}個までアップロードできます。",
    "formSurvey.successTitle": "提出済み!",
    "formSurvey.successDescription":
      "アンケートにご参加いただきありがとうございます。",
    "formSurvey.failTitle": "アンケートに参加不可！",
    "formSurvey.failDescription": "進行中のアンケートではありません。",
    "formEvent.successTitle": "提出済み!",
    "formEvent.successDescription":
      "イベントにご参加いただきありがとうございます。",
    "formEvent.failTitle": "イベント参加不可！",
    "formEvent.failDescription": "進行中のイベントではありません。",
    "promotion.successTitle": "提出済み!",
    "promotion.successDescription":
      "プロモーションにご参加いただきありがとうございます。",
    "promotion.failTitle": "プロモーション参加不可！",
    "promotion.failDescription": "進行中のプロモーションではありません。",
    "collection.failDescription": "進行中のコレクションではありません。",
    list: "リスト",

    // easyCanvas: Common
    "easyCanvas.common.brandName": "イージーキャンバス",
    "easyCanvas.common.exit": "終了",
    "easyCanvas.common.close": "閉じる",
    "easyCanvas.common.confirm": "確認",
    "easyCanvas.common.cancel": "キャンセル",
    "easyCanvas.common.edit": "編集",
    "easyCanvas.common.save": "保存",
    "easyCanvas.common.delete": "削除",
    "easyCanvas.common.reset": "リセット",
    "easyCanvas.common.apply": "適用",
    "easyCanvas.common.previous": "戻る",

    // easyCanvas: Floating
    "easyCanvas.floating.description":
      "作成したキャンペーンを追加してプレビューしましょう。プレビューしたキャンペーンをすぐに適用できます！",
    "easyCanvas.floating.tabs.checkOnMobile": "モバイルで確認する",
    "easyCanvas.floating.tabs.changeToMobileOnPc": "PCでモバイル表示に変更する",
    "easyCanvas.floating.tooltip.mobileGuide": "モバイル変更ガイド",
    "easyCanvas.floating.qrGenerating": "QRコード生成中...",
    "easyCanvas.floating.qrCodeAlt": "モバイルアクセスQRコード",
    "easyCanvas.floating.exitConfirm.body":
      "イージーキャンバスモードを終了しますか？",
    "easyCanvas.floating.mobileGuide.title": "モバイル変更ガイド",
    "easyCanvas.floating.mobileGuide.description":
      "モバイル版に変更してイージーキャンバスをご利用ください。",
    "easyCanvas.floating.mobileGuide.checkTab.instruction":
      "スマートフォンでQRコードを読み取って\nモバイルでイージーキャンバスをご利用ください",
    "easyCanvas.floating.mobileGuide.pcTab.step1":
      "右クリックで「検証」をクリック、またはF12キーを押してデベロッパーツールを開いてください",
    "easyCanvas.floating.mobileGuide.pcTab.step2":
      "画像のアイコン（Toggle device toolbar）をクリックしてページを更新してください",
    "easyCanvas.floating.mobileGuide.pcTab.step3":
      "モバイル画面でキャンペーンを確認してください",
    "easyCanvas.floating.mobileGuide.pcTab.devToolsGuideAlt":
      "デベロッパーツールガイド",

    // easyCanvas: Embedded Toolbar
    "easyCanvas.embeddedToolbar.toast.noDataToSave":
      "保存するデータがありません。",
    "easyCanvas.embeddedToolbar.toast.deleteSuccess": "削除しました。",
    "easyCanvas.embeddedToolbar.toast.deleteFailed": "削除に失敗しました。",
    "easyCanvas.embeddedToolbar.toast.saveSuccess": "保存しました。",
    "easyCanvas.embeddedToolbar.toast.saveFailed": "保存に失敗しました。",
    "easyCanvas.embeddedToolbar.deleteModal.title": "エリア削除",
    "easyCanvas.embeddedToolbar.deleteModal.body":
      "本当に削除しますか？",
    "easyCanvas.embeddedToolbar.styleModal.title": "エリアスタイル設定",
    "easyCanvas.embeddedToolbar.styleModal.alignSection": "配置",
    "easyCanvas.embeddedToolbar.styleModal.paddingSection": "余白",
    "easyCanvas.embeddedToolbar.saveModal.body1":
      "このエリアにキャンペーンを表示しますか？",
    "easyCanvas.embeddedToolbar.saveModal.body2":
      "エリア登録後、公開設定に変更するとキャンペーンが表示されます！",
    "easyCanvas.embeddedToolbar.saveModal.note":
      "*すでに公開されたキャンペーンの場合、即座に反映される場合があります。",

    // easyCanvas: Element Selector
    "easyCanvas.elementSelector.toast.campaignAdded":
      "{{name}}キャンペーンが追加されました。適用するには保存してください。",
    "easyCanvas.elementSelector.contextMenu.areaId": "エリアID",
    "easyCanvas.elementSelector.contextMenu.navigatePage": "ページ移動",
    "easyCanvas.elementSelector.contextMenu.addBeforeSelection":
      "選択したエリアの前に追加",
    "easyCanvas.elementSelector.contextMenu.addAfterSelection":
      "選択したエリアの後に追加",

    // easyCanvas: Popup Drawer
    "easyCanvas.popupDrawer.title": "キャンペーン一覧",
    "easyCanvas.popupDrawer.showOneByOne": "一つずつ表示",
    "easyCanvas.popupDrawer.badge.active": "公開",
    "easyCanvas.popupDrawer.badge.inactive": "非公開",

    // easyCanvas: Schedule Badge
    "easyCanvas.scheduleBadge.scheduled": "予約公開",
    "easyCanvas.scheduleBadge.immediate": "即時公開",

    // easyCanvas: Alerts
    "easyCanvas.alert.siteIdMismatch":
      "[コードアンドバター] インストールされたスクリプトのサイトIDが一致しません。\nインストールされたスクリプトID: {{siteId}}\n[サイト設定] - [ID]をご確認ください。\n*詳細はチャネルトークでお問い合わせください。",
    "easyCanvas.alert.sessionExpired":
      "[コードアンドバター] セッションが期限切れです。イージーキャンバスを終了します。",
    "easyCanvas.alert.authFailed":
      "[コードアンドバター] 認証に失敗しました。コードアンドバターから再度アクセスしてください。問題が繰り返される場合は管理者にお問い合わせください。",
    "easyCanvas.alert.authResultInvalid":
      "[コードアンドバター] 認証結果が無効です。コードアンドバターから再度アクセスしてください。問題が繰り返される場合は管理者にお問い合わせください。",
    "easyCanvas.alert.reAuthFailed":
      "[コードアンドバター] 再認証に失敗しました。コードアンドバターから再度アクセスしてください。問題が繰り返される場合は管理者にお問い合わせください。",
    "easyCanvas.alert.unknownAuthError":
      "[コードアンドバター] 認証で不明なエラーが発生しました。コードアンドバターから再度アクセスしてください。問題が繰り返される場合は管理者にお問い合わせください。",
  },
};

export default translationTexts;
